import { checkStatus, host } from "../api";
import { EUserCategoryType, UserCategory } from "./_type";

const usercategories = {
  createUserCategory: ({
    userId,
    categoryId,
    body,
  }: {
    userId: number;
    categoryId: number;
    body: {
      type?: EUserCategoryType;
      isNotified?: boolean;
      isGranted?: boolean;
    };
  }): Promise<UserCategory> => {
    return fetch(`${host}/api/usercategories`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
      },
      body: JSON.stringify({
        user: {
          id: userId,
        },
        category: {
          id: categoryId,
        },
        ...body,
      }),
    })
      .then(checkStatus)
      .then((res) => res?.json());
  },
  getUserCategoriesByCategory: (categoryId: number): Promise<UserCategory[]> => {
    return fetch(`${host}/api/usercategories/category/${categoryId}`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
        "content-type": "application/json",
      },
    })
      .then(checkStatus)
      .then((res) => res?.json());
  },
  updateUserCategory: ({
    userCategoryId,
    body,
  }: {
    userCategoryId: number;
    body: {
      type?: EUserCategoryType;
      isNotified?: boolean;
      isGranted?: boolean;
    };
  }): Promise<UserCategory> => {
    return fetch(`${host}/api/usercategories/${userCategoryId}`, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("jwt"),
        "content-type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(checkStatus)
      .then((res) => res?.json());
  },
};

export default usercategories;
